import React, { useEffect, useState, useRef, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Form from 'react-bootstrap/Form';
import { useSearchParams } from 'react-router-dom'
import { useForm, Controller, useFormContext, useFieldArray } from "react-hook-form";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf'
import { useTranslation } from 'react-i18next';

import toast from 'react-hot-toast';
import CurrencyInput from 'react-currency-input-field';

import "react-datepicker/dist/react-datepicker.css";
import { BankSearchFormI } from '../../resources/form-props';
import AsyncSelect from 'react-select/async';
import Select, { components } from 'react-select';
import { glClassificationApi } from '../../resources/hooks/api/glClassificationApi';
import { GLSearchFormValidate } from '../../resources/form-validator';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import { useChartAccountApi } from '../../resources/hooks/api/chartAccountApiHook';
import { useBankFeedApi } from '../../resources/hooks/api/bankFeedApiHook'
import { transTableDataApi } from '../../resources/hooks/api/transApiHook';

import './GlClassification.css'
import { SELECT_CUSTOM_STYLE, MONTHS, GL_VP } from '../../resources/constants';
import { } from '../../resources/form-props';
import { InputGroup, Spinner, Dropdown, Alert } from 'react-bootstrap';
import { calculateMaxHeightContent, lastYears, usdCurrencyFormat } from '../../resources/functions';
import { getBranch } from '../../store/user/selectors'
import SelectCustomOption from '../../components/SelectCustomOption';
import plusIcon from '../../assets/images/plus-icon-w.svg';
import CreateTransactionAdjustmentModal from 'components/Modal/ViewRegister/CreateTransactionAdjustmentModal';

interface Props {

}
interface SearchI {
    year: number,
    month: number,
    type: number
}


const ViewRegister: React.FC<Props> = () => {

    const { glTransactionlist } = glClassificationApi();
    const { glAccountsList } = useChartAccountApi();
    const { fetchRegisterTransData, feedUpdate, exportTransactionsCsv } = useBankFeedApi();
    const { createTransactionAdjustment } = transTableDataApi()

    const branchData = useSelector(getBranch)
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation("scenes.glClassification.viewRegister");

    const contentRef: any = useRef<HTMLDivElement | null>(null);

    const [records, setRecords] = useState<any>([]);
    const [sorting, setSorting] = useState<{ transaction_id: 'asc' | 'desc', transaction_at: 'asc' | 'desc' }>({
        transaction_id: 'asc',
        transaction_at: 'asc'
    });
    const [data, setData] = useState<any>([]);
    const [calculatedTotalAmount, setCalculatedTotalAmount] = useState<any>({
        totalCredit: 0,
        totalDebit: 0
    });
    const [glCreditAccount, setGlCreditAccount] = useState<any[]>([]);
    const [glAllAccount, setGlAllAccount] = useState<any[]>([]);
    const [glSearchAccount, setGlSearchAccount] = useState<any[]>([]);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedCalendar, setSelectedCalendar] = useState<any>({
        year: new Date().getFullYear(),
        month: 1,
        amount: null,
        description: '',
        account_id: null
    });
    const [selectCustomStyle, setSlectCustomStyle] = useState<any>(SELECT_CUSTOM_STYLE('#fff'));
    const [showCreateAdjustmentModal, setShowCreateAdjustmentModal] = useState(false);
    const [isThirdPartyEnabled, setIsThirdPartyEnabled] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [isExportingCsv, setIsExportingCsv] = useState<boolean>(false);

    useEffect(() => {
        fechAllAccountList().then(r => {
            setGlCreditAccount(r);
        })

        fechAllAccountList('', [...GL_VP.SALES_ACTIVITY.account, ...GL_VP.BANK_ACCOUNT.account]).then(r => {
            setGlAllAccount(r);
            setGlSearchAccount(r)
        })

    }, [])

    useEffect(() => {
        fetchBankFeedList();
    }, [selectedCalendar])
    useEffect(() => {
        setContentMaxHeight(calculateMaxHeightContent(98));
    })

    const { control: control2, handleSubmit: handleSubmit2, reset, setValue, formState: { errors: errors2 } } = useForm<BankSearchFormI>({
        defaultValues: {
            month: {
                value: '01',
                label: 'January'
            },
            year: { value: '' + new Date().getFullYear(), label: '' + new Date().getFullYear() },
            amount: null,
            description: '',
            account_id: null
        },
        resolver: yupResolver(GLSearchFormValidate)
    });

    const filterAllAccountListExceptBankSales = async (inputValue: string) => {
        const data = await fechAccountList(inputValue)
        return data;
    };

    const fechAllAccountList = (searchText: string = '', excludeVP: number[] = []): Promise<any[]> => {
        return new Promise<any>((resolve1, reject1) => {
            const params: any = {
                "page": 1,
                "per_page": 10,
                branch_id: +branchData['id']
            }
            if (searchText) {
                params['name'] = searchText;
            }

            /*if (excludeVP.length) {
                params['parent_account_not_in'] = excludeVP.join(',')
            }*/
            // params['parent_name_in'] = 'BANK ACCOUNTS';
            // params['parent_account_not_in'] = GL_VP.BANK_ACCOUNT.account.join(',');

            glAccountsList(params, (message: string, resp: any) => {

                const data = resp.data.data.result.map((e: any) => ({
                    label: e['name'] + `(${e['account']})`,
                    value: e['id']
                }));
                // setGlAllAccount(data)
                return resolve1(data);
            }, (message: string, resp: any) => {
                toast.error(message);
                return resolve1([]);
            })
        })
    }


    const fetchBankFeedList = () => {
        const params: any = {
            "page": 1,
            "per_page": 500,
            year: +selectedCalendar['year'],
            month: +selectedCalendar['month'],
            branch_id: +branchData['id']
        }

        if (selectedCalendar['amount'] !== null) {
            params['amount'] = selectedCalendar['amount'];
        }
        if (selectedCalendar['description']) {
            params['description'] = selectedCalendar['description'];
        }
        if (selectedCalendar['account_id']) {
            params['account_id'] = selectedCalendar['account_id'];
        }
        // params['id'] = 0;
        params['is_updated'] = 1;

        setIsLoading(true);
        let tempDebit = 0;

        fetchRegisterTransData(params, (message: string, resp: any) => {
            setIsThirdPartyEnabled(resp.data.data?.is_third_party_enable ?? false)
            const storeData: any[] = [];
            const result = resp.data.data.result;
            result.map((rec: any, index: any) => {
                let header: any = {};

                // account_type = 7 for gusto, no need sub heading 
                // with any object from breakdown as header
                if (rec.account_type == 7 && rec.breakdowns && rec.breakdowns.length) {
                    header = [{
                        id: rec.breakdowns[0].id,
                        previous_master_chart_of_account_id: rec.breakdowns[0].master_chart_of_account_id && {
                            label: rec.breakdowns[0].account_chart.name + '(' + rec.breakdowns[0].account_chart.account + ')',
                            value: rec.breakdowns[0].account_chart.id
                        } || null,
                        master_chart_of_account_id: rec.breakdowns[0].master_chart_of_account_id && {
                            label: rec.breakdowns[0].account_chart.name + '(' + rec.breakdowns[0].account_chart.account + ')',
                            value: rec.breakdowns[0].account_chart.id
                        } || null,
                        account_type: rec.breakdowns[0].account_type,
                        name: rec.breakdowns[0].account_chart.name,
                        account: rec.breakdowns[0].account_chart.account,
                        account_value: rec.breakdowns[0].account_value,
                        debit: rec.breakdowns[0].txn_type == 1 ? rec.breakdowns[0].account_value : 0,
                        credit: rec.breakdowns[0].txn_type == 2 ? rec.breakdowns[0].account_value : 0,
                        revrex_account_id: rec.breakdowns[0].account_chart.revrex_account_id,
                        isEdit: false,
                        showLoader: false,
                        errorMsg: null
                    }]
                }
                else {
                    header = rec.breakdowns.map((breakdown: any, index: any) => {
                        if (breakdown.account_chart) {
                            if (rec.account_type == 3 && breakdown.account_type == 'Deposit') {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart && breakdown.account_chart.name || '',
                                    account: breakdown.account_chart && breakdown.account_chart.account || '',
                                    account_value: breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart && breakdown.account_chart.revrex_account_id || null,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            }
                            else if (rec.account_type == 1 && breakdown.account_type == 'Credit_Deposit') {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart.name,
                                    account: breakdown.account_chart.account,
                                    account_value: breakdown.txn_type == 2 ? breakdown.account_value * -1 : breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart.revrex_account_id,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            } else if (rec.account_type == 2 && breakdown.account_type == 'Gross_Sale') {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart.name,
                                    account: breakdown.account_chart.account,
                                    account_value: breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart.revrex_account_id,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            } else if (rec.account_type == 4 && breakdown.account_type == 'Overshort') {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart.name,
                                    account: breakdown.account_chart.account,
                                    account_value: breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart.revrex_account_id,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            } else if (rec.account_type == 5 && breakdown.account_type == 'Credit_Adjustment') {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart.name,
                                    account: breakdown.account_chart.account,
                                    account_value: breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart.revrex_account_id,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            } else if (rec.account_type == 6 && ['Credit_Deposit', 'Debit_Deposit'].includes(breakdown.account_type)) {
                                return {
                                    id: breakdown.id,
                                    previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                        label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                        value: breakdown.account_chart.id
                                    } || null,
                                    account_type: breakdown.account_type,
                                    name: breakdown.account_chart.name,
                                    account: breakdown.account_chart.account,
                                    account_value: breakdown.txn_type == 2 ? breakdown.account_value * -1 : breakdown.account_value,
                                    debit: breakdown.txn_type == 1 ? breakdown.account_value : 0,
                                    credit: breakdown.txn_type == 2 ? breakdown.account_value : 0,
                                    revrex_account_id: breakdown.account_chart.revrex_account_id,
                                    isEdit: false,
                                    showLoader: false,
                                    errorMsg: null
                                }
                            }
                            return null;
                        }
                    }).filter((item: any) => item);
                }


                let isFirstGrossSaleSkipped = false;

                const subObjects = rec.breakdowns
                    .map((breakdown: any, index: any) => {
                        if (breakdown.account_chart) {
                            if (
                                breakdown.account_type !== 'Credit_Deposit' &&
                                breakdown.account_type !== 'Deposit' &&
                                breakdown.account_type !== 'Gross_Sale' &&
                                breakdown.account_type !== 'Overshort' &&
                                breakdown.account_type !== 'Credit_Adjustment'
                            ) {
                                if (rec.account_type == 6) {

                                } else {
                                    return {
                                        id: breakdown.id,
                                        previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                            label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                            value: breakdown.account_chart.id
                                        } || null,
                                        master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                            label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                            value: breakdown.account_chart.id
                                        } || null,
                                        account_type: breakdown.account_type,
                                        name: breakdown.account_chart && breakdown.account_chart.name || '',
                                        account: breakdown.account_chart && breakdown.account_chart.account || '',
                                        account_value: breakdown.account_value,
                                        debit: breakdown.txn_type == 1 ? breakdown.account_value : "",
                                        credit: breakdown.txn_type == 2 ? breakdown.account_value : "",
                                        revrex_account_id: breakdown.account_chart && breakdown.account_chart.revrex_account_id || null,
                                        isEdit: false,
                                        showLoader: false,
                                        errorMsg: null
                                    };
                                }

                            }

                            // Handle 'Gross_Sale' case
                            if (breakdown.account_type === 'Gross_Sale') {
                                if (isFirstGrossSaleSkipped) {
                                    return {
                                        id: breakdown.id,
                                        previous_master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                            label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                            value: breakdown.account_chart.id
                                        } || null,
                                        master_chart_of_account_id: breakdown.master_chart_of_account_id && {
                                            label: breakdown.account_chart.name + '(' + breakdown.account_chart.account + ')',
                                            value: breakdown.account_chart.id
                                        } || null,
                                        account_type: breakdown.account_type,
                                        name: breakdown.account_chart && breakdown.account_chart.name || '',
                                        account: breakdown.account_chart && breakdown.account_chart.account || '',
                                        account_value: breakdown.account_value,
                                        debit: breakdown.txn_type == 1 ? breakdown.account_value : "",
                                        credit: breakdown.txn_type == 2 ? breakdown.account_value : "",
                                        revrex_account_id: breakdown.account_chart && breakdown.account_chart.revrex_account_id || null,
                                        isEdit: false,
                                        showLoader: false,
                                        errorMsg: null
                                    };
                                } else {
                                    isFirstGrossSaleSkipped = true;
                                    return null; // Skip the first row with 'Gross_Sale'
                                }
                            }
                        }
                        return null;
                    })
                    .filter((item: any) => item);

                // if ( subObjects.length ) {
                const main_rec = {
                    parent_id: rec.parent_id,
                    transaction_id: rec.id,
                    description: rec.description,
                    transaction_at: rec.transaction_at,
                    header: header.length && header[0] || {},
                    subRecord: rec.account_type == 7 ? [] : subObjects,
                }
                storeData.push(main_rec);
                // }

            })

            const calculatedTotal = storeData.reduce((acc: any, record: any) => {
                const _total = record['subRecord'].reduce((subAcc: any, _record: any) => {
                    subAcc['totalSubDebit'] += Math.abs(_record['debit'] || 0);
                    subAcc['totalSubCredit'] += Math.abs(_record['credit'] || 0);
                    return subAcc;
                }, { totalSubDebit: 0, totalSubCredit: 0 });
                acc['totalDebit'] += Math.abs(record['header'] && record['header']['debit'] || 0) + _total['totalSubDebit'];
                acc['totalCredit'] += Math.abs(record['header'] && record['header']['credit'] || 0) + _total['totalSubCredit'];
                return acc;
            }, { totalDebit: 0, totalCredit: 0 });

            setCalculatedTotalAmount({
                totalCredit: calculatedTotal['totalCredit'],
                totalDebit: calculatedTotal['totalDebit']
            })

            //console.log(storeData);

            setData(storeData);
            //setData(storeData);
            //setData(res);
            setIsLoading(false);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })

    }
    const filterAllAccountList = async (inputValue: string) => {
        const data = await fechAllAccountList(inputValue)
        return data;
    };

    const filterSearchAccountList = async (inputValue: string) => {
        const data = await fechAllAccountList(inputValue)
        return data;
    };

    /*const resetFilter = () => {
        reset({
            month: {
                value: 0,
                label: 'All'
            },
            year: { value: 0, label: 'All' },
            amount: null
        })
        setSelectedCalendar({
            year: 0,
            month: 0,
            amount: null
        })
    }*/

    const resetFilter = () => {
        setValue('amount', null);
        setValue('description', '');
        setValue('account_id', null);
        setSelectedCalendar({
            ...selectedCalendar,
            amount: null,
            description: '',
            account_id: null
        })
    }

    const processSearchData = (data: any) => {
        setSelectedCalendar({
            year: +data['year']['value'],
            month: +data['month']['value'],
            amount: data['amount'],
            description: data['description'],
            account_id: data['account_id']?.value || null
        })
    }

    function groupBy(arr: any, property: any) {
        return arr.reduce((acc: any, obj: any) => {
            const key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    const onChangeMasterChart = (event: any, groupIndex: number, recordIndex: number | null) => {
        setData((prevState: any) => {
            const objects = JSON.parse(JSON.stringify(prevState));
            const groupData = objects[groupIndex];
            if (recordIndex === null) {
                groupData['header']['master_chart_of_account_id'] = event;
            } else {
                groupData['subRecord'][recordIndex]['master_chart_of_account_id'] = event;
            }
            objects.splice(groupIndex, 1, groupData)

            return objects;
        })
    }

    const _handleEdit = (groupIndex: number, recordIndex: number | null, toggle: boolean) => {
        setData((prevState: any) => {
            const objects = JSON.parse(JSON.stringify(prevState));
            const groupData = objects[groupIndex];

            if (recordIndex === null) {
                if (!toggle) {
                    groupData['header']['master_chart_of_account_id'] = groupData['header']['previous_master_chart_of_account_id'];
                }
                groupData['header']['isEdit'] = toggle;
                console.log('groupData: ', groupData)
            } else {
                if (!toggle) {
                    groupData['subRecord'][recordIndex]['master_chart_of_account_id'] = groupData['subRecord'][recordIndex]['previous_master_chart_of_account_id'];
                }
                groupData['subRecord'][recordIndex]['isEdit'] = toggle;
            }
            objects.splice(groupIndex, 1, groupData)

            return objects;
        })
    }

    const _handleLoader = (groupIndex: number, recordIndex: number | null, toggle: boolean) => {
        setData((prevState: any) => {
            const objects = JSON.parse(JSON.stringify(prevState));
            const groupData = objects[groupIndex];
            if (recordIndex === null) {
                groupData['header']['showLoader'] = toggle;
            } else {
                groupData['subRecord'][recordIndex]['showLoader'] = toggle;
            }
            objects.splice(groupIndex, 1, groupData)

            return objects;
        })
    }

    const _handleUpdate = (record: any, groupIndex: number, recordIndex: number | null) => {
        _handleLoader(groupIndex, recordIndex, true);
        const objects = JSON.parse(JSON.stringify(data));
        const groupData = objects[groupIndex];

        if (!record['master_chart_of_account_id']) {
            if (recordIndex === null) {
                groupData['header']['errorMsg'] = 'GL is required';
            } else {
                groupData['subRecord'][recordIndex]['errorMsg'] = 'GL is required';
            }
            objects.splice(groupIndex, 1, groupData)
            setData(objects);
            return;
        }

        processData(record).then((resp: any) => {
            if (recordIndex === null) {
                groupData['header']['previous_master_chart_of_account_id'] = record['master_chart_of_account_id'];
                groupData['header']['isEdit'] = false;
            } else {
                groupData['subRecord'][recordIndex]['previous_master_chart_of_account_id'] = record['master_chart_of_account_id'];
                groupData['subRecord'][recordIndex]['isEdit'] = false;
            }
            objects.splice(groupIndex, 1, groupData)
            setData(objects);
            _handleLoader(groupIndex, recordIndex, false);
        }).catch((err: any) => {
            _handleLoader(groupIndex, recordIndex, false);
        })

    }

    const processData = (record: any) => {
        return new Promise<any>((resolve, reject) => {
            const params: any = {
                breakdown_id: record['id'],
                master_chart_of_account_id: record['master_chart_of_account_id']['value'],
                branch_id: +branchData['id']
            }
            feedUpdate(params, (message: string, resp: any) => {
                toast.success(message);
                return resolve(resp)
            }, (message: string, resp: any) => {
                toast.error(message);
                return reject(resp);
            })
        })
    }
    const toTwoDecimal = (value: any) => parseFloat(value).toFixed(2);

    const handleAdjustmentClick = () => {
        setShowCreateAdjustmentModal(true);
    };


    const fechAccountList = (searchText: string = '', excludeVP: number[] = [], includeVP: number[] = []): Promise<any[]> => {
        return new Promise<any>((resolve, reject) => {
            const params: any = {
                "page": 1,
                "per_page": 10,
                branch_id: +branchData['id']
            }
            if (searchText) {
                params['name'] = searchText;
            }
            if (excludeVP.length) {
                params['parent_account_not_in'] = excludeVP.join(',')
            }
            if (includeVP.length) {
                params['parent_account_in'] = includeVP.join(',')
            }

            glAccountsList(params, (message: string, resp: any) => {
                const data = resp.data.data.result.map((e: any) => ({
                    label: e['name'] + `(${e['account']})`,
                    value: e['id']
                }));
                return resolve(data);
            }, (message: string, resp: any) => {
                toast.error(message);
                return resolve([]);
            })
        })
    }

    const submitAdjustment = (data: any) => {
        setIsLoading(true);
        const params: any = data.map((e: any) => ({
            "description": e.description,
            "transaction_at": moment(e.transaction_at).format('YYYY-MM-DDTHH:mm:ss'),
            "adjustment_debit": e.adjustment_debit,
            "adjustment_credit": e.adjustment_credit,
            "adjustment_master_debit_account_id": e.adjustment_master_debit_account_id.value,
            "adjustment_master_credit_account_id": e.adjustment_master_credit_account_id.value
        }))

        createTransactionAdjustment({ params, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.success(message)

            fetchBankFeedList();

        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    };

    const sortTable = (field: string, action: number) => {
        setData((prevData: any[]) => {
            const sortedData = [...prevData].sort((a, b) => {
                /*console.log('a: ', a, ' b: ', b)
                if (a[field] === b[field]) {
                    // Maintain the order of the other field in sorting
                    const otherField = field === 'transaction_id' ? 'transaction_at' : 'transaction_id';
                    return sorting[otherField] === 'asc'
                        ? a[otherField] > b[otherField] ? 1 : -1
                        : a[otherField] < b[otherField] ? 1 : -1;
                }*/
                return action === 1
                    ? a[field] > b[field] ? 1 : -1
                    : a[field] < b[field] ? 1 : -1;
            });

            return sortedData;
        });

        setSorting((prevSorting) => ({
            ...prevSorting,
            [field]: action === 1 ? 'asc' : 'desc',
        }));
    };

    useEffect(() => {
        const year: string = searchParams.get('year') || '' + new Date().getFullYear();
        const month: string = searchParams.get('month') || '' + 1;

        setValue('year', {
            value: year,
            label: year
        });
        setValue('month', {
            value: month,
            label: MONTHS[+month - 1].label
        });

        setSelectedCalendar({
            ...selectedCalendar,
            year: +year,
            month: +month,
        })
    }, [searchParams])

    function chunkArray<T>(arr: T[], size: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    }

    const _handlePdfGenerator = async () => {
        if (!contentRef.current) {
            return;
        }

        try {
            setIsDownloading(true)
            const pageWidth = 210;
            const pageHeight = 297;
            const margin = 15;
            const contentWidth = pageWidth - margin * 2;
            const pdf = new jsPDF('p', 'mm', 'a4');

            // Cloning the table to avoid modifications to the original DOM
            const originalTable = contentRef.current.querySelector('.table');
            const clonedTable = originalTable.cloneNode(true) as HTMLElement;

            // Adding unique class for PDF export
            clonedTable.classList.add('pdf-export-table');

            // Adding PDF-only classes to thead/tbody
            const thead = clonedTable.querySelector('thead');
            if (thead) thead.classList.add('pdf-export-header');
            const tbodies = clonedTable.querySelectorAll('tbody');
            tbodies.forEach(tbody => tbody.classList.add('pdf-export-row'));

            // Removing action column (the 9th column in each row)
            const actionCells = clonedTable.querySelectorAll('th:nth-child(9), td:nth-child(9)');
            actionCells.forEach(cell => cell.remove());

            // Preparing the temp div
            const tempDiv = document.createElement('div');
            tempDiv.style.position = 'absolute';
            tempDiv.style.left = '-9999px';

            // Injecting custom styles for PDF only, scoped to .pdf-export-table
            const style = document.createElement('style');
            style.innerHTML = `
                .pdf-export-table .pdf-export-header th {
                    background: #1560C5 !important;
                    color: #fff !important;
                    font-weight: bold !important;
                    border: 1px solid #2064bdff !important;
                    padding: 8px !important;
                }
                .pdf-export-table .pdf-export-row th:nth-child(3),
                .pdf-export-table .pdf-export-row td:nth-child(3) {
                    white-space: normal !important;
                    word-break: break-word !important;
                    max-width: 300px !important;
                    overflow-wrap: break-word !important;
                }
                .pdf-export-table .pdf-export-row .text-truncate {
                    white-space: normal !important;
                    overflow: visible !important;
                    text-overflow: unset !important;
                    max-width: 300px !important;
                }
                .pdf-export-table .pdf-export-header th:nth-child(1),
                .pdf-export-table .pdf-export-row th:nth-child(1),
                .pdf-export-table .pdf-export-row td:nth-child(1) {
                    min-width: 90px !important;
                    width: 90px !important;
                }
            `;
            tempDiv.appendChild(style);
            tempDiv.appendChild(clonedTable);
            document.body.appendChild(tempDiv);

            // Now selecting from tempDiv, not from the main DOM
            const tableHeaderSection = tempDiv.querySelector('.pdf-export-header');
            const tableBodySection = tempDiv.querySelectorAll('.pdf-export-row');

            const addCustomHeader = (doc: jsPDF, pageNum: number) => {
                doc.setFontSize(10);
                doc.setTextColor(40);
                const monthName = MONTHS[+selectedCalendar.month - 1]?.label || '';
                doc.text(t("table.summary.report.title", { monthName, year: selectedCalendar.year }), margin, 8);

                doc.setFontSize(8);
                doc.text(t("table.summary.report.generated", { date: moment().format('YYYY-MM-DD HH:mm:ss') }), pageWidth - 70, 8);

                doc.setDrawColor(200);
                doc.line(margin, 10, pageWidth - margin, 10);
            };

            addCustomHeader(pdf, 1);

            let currentY = 14;

            if (tableHeaderSection) {
                const contentCanvas = await html2canvas(tableHeaderSection as HTMLElement, {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                });

                const contentImgWidth = contentWidth;
                const contentImgHeight = (contentCanvas.height * contentWidth) / contentCanvas.width;

                if (contentImgHeight > pageHeight - currentY - margin) {
                    pdf.addPage();
                    currentY = margin;
                }

                pdf.addImage(contentCanvas.toDataURL('image/png'), 'PNG', margin, currentY, contentImgWidth, contentImgHeight);

                currentY += contentImgHeight;
            }

            for (let i = 0; i < tableBodySection.length; i++) {
                const row = tableBodySection[i] as HTMLElement;
                const rowCanvas = await html2canvas(row, {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                });

                const rowImgWidth = contentWidth;
                const rowImgHeight = (rowCanvas.height * contentWidth) / rowCanvas.width;

                if (rowImgHeight > pageHeight - currentY - margin) {
                    pdf.addPage();
                    currentY = margin;
                }

                pdf.addImage(rowCanvas.toDataURL('image/png'), 'PNG', margin, currentY, rowImgWidth, rowImgHeight);

                currentY += rowImgHeight;
            }

            // Cleaning up the temporary element
            document.body.removeChild(tempDiv);

            const pdfOutput = pdf.output('blob');
            const pdfUrl = URL.createObjectURL(pdfOutput);
            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = `transaction_register_${selectedCalendar.year}_${selectedCalendar.month}.pdf`;
            a.style.display = 'none';

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(pdfUrl);
            setIsDownloading(false);

        } catch (error) {
            console.error('Error generating PDF:', error);
            setIsDownloading(false);
        }
    }

    const _handleCsvExport = () => {
        if (data.length === 0) {
            toast.error('No data available to export');
            return;
        }

        setIsExportingCsv(true);

        // Using the same parameters as fetchRegisterTransData
        const params: any = {
            "page": 1,
            "per_page": 500,
            year: +selectedCalendar['year'],
            month: +selectedCalendar['month'],
            branch_id: +branchData['id']
        }

        if (selectedCalendar['amount'] !== null) {
            params['amount'] = selectedCalendar['amount'];
        }
        if (selectedCalendar['description']) {
            params['description'] = selectedCalendar['description'];
        }
        if (selectedCalendar['account_id']) {
            params['account_id'] = selectedCalendar['account_id'];
        }
        // params['id'] = 0;
        params['is_updated'] = 1;

        exportTransactionsCsv(params, (msg: string, blob: any) => {
            try {

                if (!(blob instanceof Blob)) {
                    toast.error('Invalid file format received');
                    setIsExportingCsv(false);
                    return;
                }

                const url = window.URL.createObjectURL(blob);

                // Create download link
                const link = document.createElement('a');
                link.href = url;
                link.download = `transaction_register_${selectedCalendar.year}_${selectedCalendar.month}.csv`;
                link.style.display = 'none';

                // Trigger download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Clean up
                window.URL.revokeObjectURL(url);

                toast.success('CSV exported successfully');
            } catch (error) {
                toast.error('Failed to download CSV file');
            }
            setIsExportingCsv(false);
        },
            (message: string, resp: any) => {
                setIsExportingCsv(false);
                toast.error(message || 'Failed to export CSV');
            }
        );
    }

    return (
        <div className="main-container flex-grow-1" ref={contentRef}>
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t("title")}</h1>
                        </div>
                    </div>
                </div>

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className="table-top pdf-container" id="ux_page_filter">
                            <div className="row">
                                <Form >
                                    <div className="col-sm-12">
                                        <div className="filter-wrap d-flex justify-content-between align-items-center">
                                            <div className="d-flex flex-grow-1">
                                                <Form.Group className="filter-box" controlId="formBasicEmail">
                                                    <Controller
                                                        name="month"
                                                        control={control2}
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                options={MONTHS}
                                                                className={'zindex-10'}
                                                            />
                                                        )}
                                                    />

                                                    {
                                                        errors2 && errors2['month'] && errors2['month'].message && (
                                                            <Form.Text className="text-danger">
                                                                {errors2['month'].message as ReactNode || ''}
                                                            </Form.Text>
                                                        ) || ''
                                                    }

                                                </Form.Group>
                                                <Form.Group className="filter-box" controlId="formBasicEmail">
                                                    <Controller
                                                        name="year"
                                                        control={control2}
                                                        render={({ field }) => (
                                                            // <Select
                                                            //     {...field}
                                                            //     options={[{label: 'All', value: 0}, ...lastYears(5)]}
                                                            //     className={'zindex-10'}
                                                            // />
                                                            <Select
                                                                {...field}
                                                                options={lastYears(5)}
                                                                className={'zindex-10'}
                                                            />
                                                        )}
                                                    />
                                                    {
                                                        errors2 && errors2['year'] && errors2['year'].message && (
                                                            <Form.Text className="text-danger">
                                                                {errors2['year'].message as ReactNode || ''}
                                                            </Form.Text>
                                                        ) || ''
                                                    }

                                                </Form.Group>
                                                <Form.Group className="filter-box w-10" controlId="formBasicEmail">
                                                    <Controller
                                                        name={`amount`}
                                                        control={control2}
                                                        render={({ field }) => (
                                                            <InputGroup hasValidation>
                                                                <InputGroup.Text>$</InputGroup.Text>
                                                                <CurrencyInput
                                                                    className={`form-control`}
                                                                    placeholder="0.00"
                                                                    value={field.value ?? ''}
                                                                    onValueChange={(value) => {
                                                                        field.onChange(value || null);
                                                                    }}
                                                                    allowDecimals={true}
                                                                    decimalsLimit={2}
                                                                    decimalSeparator="."
                                                                    groupSeparator=","
                                                                    disableAbbreviations
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            handleSubmit2(processSearchData)();
                                                                        }
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                        )}
                                                    />
                                                    {
                                                        errors2 && errors2['amount'] && errors2['amount'].message && (
                                                            <Form.Text className="text-danger">
                                                                {errors2['amount'].message as ReactNode || ''}
                                                            </Form.Text>
                                                        ) || ''
                                                    }

                                                </Form.Group>

                                                <Form.Group className="filter-box" controlId="formBasicEmail">
                                                    <Controller
                                                        name={`description`}
                                                        control={control2}
                                                        render={({ field }) => (
                                                            <InputGroup hasValidation>
                                                                <input
                                                                    type={"text"}
                                                                    className={`form-control`}
                                                                    placeholder={t('filter.placeholder.description')}
                                                                    {...field}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            handleSubmit2(processSearchData)();
                                                                        }
                                                                    }}
                                                                />
                                                            </InputGroup>
                                                        )}
                                                    />
                                                    {
                                                        errors2 && errors2['description'] && errors2['description'].message && (
                                                            <Form.Text className="text-danger">
                                                                {errors2['description'].message as ReactNode || ''}
                                                            </Form.Text>
                                                        ) || ''
                                                    }

                                                </Form.Group>

                                                <Form.Group className="filter-box" controlId="formBasicEmail">
                                                    <Controller
                                                        name={`account_id`}
                                                        control={control2}
                                                        render={({ field: { value, onChange, onBlur } }) => (
                                                            <AsyncSelect
                                                                isClearable={true}
                                                                placeholder={t('filter.placeholder.select')}
                                                                defaultOptions={glSearchAccount}
                                                                loadOptions={filterSearchAccountList}
                                                                onChange={(e: any) => {
                                                                    onChange(e);
                                                                }}
                                                                onKeyDown={(e: any) => {
                                                                    if (e.key === 'Enter') {
                                                                        handleSubmit2(processSearchData)();
                                                                    }
                                                                }}
                                                                className="vp-dropdown zindex-10"
                                                                menuPosition="fixed"
                                                                value={value}
                                                                defaultValue={value}
                                                                styles={selectCustomStyle}
                                                            />
                                                        )}
                                                    />
                                                    {
                                                        errors2 && errors2['account_id'] && errors2['account_id'].message && (
                                                            <Form.Text className="text-danger">
                                                                {errors2['account_id'].message as ReactNode || ''}
                                                            </Form.Text>
                                                        ) || ''
                                                    }

                                                </Form.Group>

                                                <div className="filter-btn">
                                                    <button type="button" onClick={handleSubmit2(processSearchData)}><i className="fa fa-search" aria-hidden="true"></i>&nbsp;&nbsp; {t('finter.btn.title')}</button>
                                                </div> &nbsp;&nbsp;
                                                <div className="filter-btn">
                                                    <button type="button" className='button-secondary' onClick={resetFilter}><i className='fa fa-refresh' /> &nbsp;&nbsp;{t('filter.reset.btn.title')}</button>
                                                </div>&nbsp;&nbsp;

                                                {
                                                    calculatedTotalAmount["totalDebit"].toFixed(2) === calculatedTotalAmount["totalCredit"].toFixed(2) && (
                                                        <div>
                                                            <Dropdown align="end">
                                                                <Dropdown.Toggle
                                                                    variant="secondary"
                                                                    disabled={isDownloading || isExportingCsv}
                                                                    className="button-secondary d-flex align-items-center export-dropdown-toggle"
                                                                >
                                                                    {(isDownloading || isExportingCsv) ? (
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true">
                                                                        </span>) : (
                                                                        <i className="fa fa-download me-2" />
                                                                    )}

                                                                    {t('action.export.title')}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={_handleCsvExport}
                                                                        className="d-flex align-items-center custom-selected"
                                                                    >
                                                                        <span>{t('action.export.csv.btn.title')}</span>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={_handlePdfGenerator}
                                                                        className="d-flex align-items-center custom-selected"
                                                                    >
                                                                        <span>{t('action.export.pdf.btn.title')}</span>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-btn">
                                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                                            <div className="loader"></div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>

                        <br></br>
                        <div className="table-responsive list-table table-scroll">
                            {
                                calculatedTotalAmount["totalDebit"].toFixed(2) !== calculatedTotalAmount["totalCredit"].toFixed(2) && (
                                    <Alert variant={'info'}>
                                        <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                                        {t('transaction.not.balanced')}
                                    </Alert>
                                ) || <></>
                            }

                            {!isThirdPartyEnabled && data.length > 0 && (
                                <div className="filter-btn ms-auto d-flex justify-content-end mb-2">
                                    <button type="button" onClick={handleAdjustmentClick} className="button-tertiary">
                                        <img src={plusIcon} alt="" /> {t('transaction.adjustment')}
                                    </button>
                                </div>
                            )}
                            <table className="table table-default">
                                <thead className="pdf-table-header">
                                    <tr className="align-middle">
                                        <th className="text-start">
                                            <div className='align-items-center d-flex justify-content-between'>
                                                <span>{t('table.header.txn.id')}</span>
                                                {
                                                    sorting.transaction_id === 'asc' && (
                                                        <i className="fa-solid fa-sort-up cursor-pointer" onClick={() => sortTable('transaction_id', -1)}></i>
                                                    ) || (
                                                        <i className="fa-solid fa-sort-down cursor-pointer" onClick={() => sortTable('transaction_id', 1)}></i>
                                                    )
                                                }
                                            </div>
                                        </th>
                                        <th className="text-center">
                                            <div className='align-items-center d-flex justify-content-between'>
                                                <span>{t('table.header.txn.date')}</span>
                                                {
                                                    sorting.transaction_at === 'asc' && (
                                                        <i className="fa-solid fa-sort-up cursor-pointer" onClick={() => sortTable('transaction_at', -1)}></i>
                                                    ) || (
                                                        <i className="fa-solid fa-sort-down cursor-pointer" onClick={() => sortTable('transaction_at', 1)}></i>
                                                    )
                                                }
                                            </div>
                                        </th>
                                        <th className="text-start">{t('table.header.description')}</th>
                                        <th className="text-end">{t('table.header.amount')}</th>
                                        <th className="text-end"></th>
                                        <th className="text-start">{t('table.header.account')}</th>
                                        <th className="text-end">{t('table.header.debit')}</th>
                                        <th className="text-end">{t('table.header.credit')}</th>
                                        <th className="text-center">{t('table.header.action')}</th>
                                    </tr>
                                </thead>
                                {/* <tbody> */}
                                {
                                    data.length > 0 ? (
                                        <>
                                            {chunkArray(data, 4).map((group, groupIndex) => (
                                                <tbody key={groupIndex} className="pdf-table-row">
                                                    {group.map((rec: any, index: any) => (
                                                        <React.Fragment key={index}>
                                                            <tr
                                                                className={
                                                                    index % 2 === 0
                                                                        ? "align-middle"
                                                                        : "align-middle grey-background"
                                                                }
                                                            >
                                                                <th className="text-start">{rec.transaction_id}</th>
                                                                <th className="text-center">
                                                                    {moment(rec.transaction_at).format("MM-DD-YYYY h:mm:ss")}
                                                                </th>
                                                                <th
                                                                    className="text-start text-truncate"
                                                                    style={{ maxWidth: "110px" }}
                                                                    title={rec.description || "NA"}
                                                                >
                                                                    {rec.description || "NA"}
                                                                </th>
                                                                <th className="text-end">
                                                                    {rec?.header?.account_value < 0
                                                                        ? `(${usdCurrencyFormat(
                                                                            Math.abs(rec?.header?.account_value)
                                                                        )})`
                                                                        : usdCurrencyFormat(rec?.header?.account_value || 0)}
                                                                </th>
                                                                <th></th>
                                                                <th className="text-start">
                                                                    {rec.header.isEdit ? (
                                                                        <>
                                                                            <AsyncSelect
                                                                                isClearable={false}
                                                                                placeholder={t("table.acc.select.placeholder")}
                                                                                defaultOptions={glCreditAccount}
                                                                                loadOptions={filterAllAccountList}
                                                                                defaultValue={rec.header.master_chart_of_account_id}
                                                                                onChange={(e: any) =>
                                                                                    onChangeMasterChart(e, groupIndex * 4 + index, null)
                                                                                }
                                                                                className="vp-dropdown"
                                                                                menuPosition="fixed"
                                                                                styles={selectCustomStyle}
                                                                                components={{ Option: SelectCustomOption }}
                                                                            />
                                                                            {rec.header.errorMsg && (
                                                                                <span className="text-danger">
                                                                                    {rec.header.errorMsg}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    ) : rec.header.master_chart_of_account_id ? (
                                                                        <span className="text-wrap">
                                                                            {rec.header.master_chart_of_account_id.label}
                                                                        </span>
                                                                    ) : (
                                                                        <span>NA</span>
                                                                    )}
                                                                </th>
                                                                <th className="text-end">
                                                                    {usdCurrencyFormat(Math.abs(rec?.header?.debit || 0))}
                                                                </th>
                                                                <th className="text-end">
                                                                    {usdCurrencyFormat(Math.abs(rec?.header?.credit || 0))}
                                                                </th>
                                                                {[
                                                                    "Gross_Sale",
                                                                    "Credit_Adjustment",
                                                                    "Debit_Adjustment",
                                                                ].includes(rec.header.account_type) &&
                                                                    !isThirdPartyEnabled ? (
                                                                    <th className="text-center">
                                                                        {rec.header.isEdit ? (
                                                                            <div>
                                                                                {rec.header.showLoader ? (
                                                                                    <Spinner animation="border" size="sm" />
                                                                                ) : (
                                                                                    <>
                                                                                        <span
                                                                                            title={t('table.edit.cancel.btn.title')}
                                                                                            className="cursor-pointer text-danger"
                                                                                            onClick={() => _handleEdit(groupIndex * 4 + index, null, false)}
                                                                                        >
                                                                                            <i
                                                                                                className="fa fa-cancel"
                                                                                                aria-hidden="true"
                                                                                            ></i>
                                                                                        </span>
                                                                                        &nbsp;&nbsp;&nbsp;
                                                                                        <span
                                                                                            title={t('table.edit.save.btn.title')}
                                                                                            className="cursor-pointer text-success"
                                                                                            onClick={() => _handleUpdate(rec.header, groupIndex * 4 + index, null)}
                                                                                        >
                                                                                            <i
                                                                                                className="fa fa-save"
                                                                                                aria-hidden="true"
                                                                                            ></i>
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <span
                                                                                title={t('table.edit.update.btn.title')}
                                                                                className="cursor-pointer text-secondary"
                                                                                onClick={() => _handleEdit(groupIndex * 4 + index, null, true)}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-pencil"
                                                                                    aria-hidden="true"
                                                                                ></i>
                                                                            </span>
                                                                        )}
                                                                    </th>
                                                                ) : (
                                                                    <th></th>
                                                                )}
                                                            </tr>

                                                            {rec.subRecord.map((record: any, recordIndex: any) => (
                                                                <tr
                                                                    key={recordIndex}
                                                                    className={
                                                                        index % 2 === 0
                                                                            ? "align-middle"
                                                                            : "align-middle grey-background"
                                                                    }
                                                                >
                                                                    <td className="text-start"></td>
                                                                    <td className="text-center"></td>
                                                                    <td className="text-start"></td>
                                                                    <td className="text-end"></td>
                                                                    <td></td>
                                                                    <td className="text-start">
                                                                        {record.isEdit ? (
                                                                            <>
                                                                                <AsyncSelect
                                                                                    isClearable={false}
                                                                                    placeholder={t("table.acc.select.placeholder")}
                                                                                    defaultOptions={glCreditAccount}
                                                                                    loadOptions={filterAllAccountList}
                                                                                    defaultValue={record.master_chart_of_account_id}
                                                                                    onChange={(e: any) =>
                                                                                        onChangeMasterChart(e, groupIndex * 4 + index, recordIndex)
                                                                                    }
                                                                                    className="vp-dropdown"
                                                                                    menuPosition="fixed"
                                                                                    styles={selectCustomStyle}
                                                                                    components={{ Option: SelectCustomOption }}
                                                                                />
                                                                                {record.errorMsg && (
                                                                                    <span className="text-danger">
                                                                                        {record.errorMsg}
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        ) : record.master_chart_of_account_id ? (
                                                                            <span className="text-wrap">
                                                                                {record.master_chart_of_account_id.label}
                                                                            </span>
                                                                        ) : (
                                                                            <span>NA</span>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {usdCurrencyFormat(Math.abs(record.debit))}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {usdCurrencyFormat(Math.abs(record.credit))}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {!isThirdPartyEnabled &&
                                                                            (record.isEdit ? (
                                                                                <div>
                                                                                    {record.showLoader ? (
                                                                                        <Spinner animation="border" size="sm" />
                                                                                    ) : (
                                                                                        <>
                                                                                            <span
                                                                                                title={t('table.edit.cancel.btn.title')}
                                                                                                className="cursor-pointer text-danger"
                                                                                                onClick={() =>
                                                                                                    _handleEdit(groupIndex * 4 + index, recordIndex, false)
                                                                                                }
                                                                                            >
                                                                                                <i
                                                                                                    className="fa fa-cancel"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                            </span>
                                                                                            &nbsp;&nbsp;&nbsp;
                                                                                            <span
                                                                                                title={t('table.edit.save.btn.title')}
                                                                                                className="cursor-pointer text-success"
                                                                                                onClick={() =>
                                                                                                    _handleUpdate(record, groupIndex * 4 + index, recordIndex)
                                                                                                }
                                                                                            >
                                                                                                <i
                                                                                                    className="fa fa-save"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <span
                                                                                    title={t('table.edit.update.btn.title')}
                                                                                    className="cursor-pointer text-secondary"
                                                                                    onClick={() => _handleEdit(groupIndex * 4 + index, recordIndex, true)}
                                                                                >
                                                                                    <i
                                                                                        className="fa fa-pencil"
                                                                                        aria-hidden="true"
                                                                                    ></i>
                                                                                </span>
                                                                            ))}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            ))}

                                            <tbody className="pdf-table-row">
                                                <tr>
                                                    <td colSpan={3} className="text-end">
                                                        <strong>{t("table.summary.total")}</strong>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="text-end">
                                                        <h6>
                                                            {usdCurrencyFormat(
                                                                calculatedTotalAmount["totalDebit"].toFixed(2)
                                                            )}
                                                        </h6>
                                                    </td>
                                                    <td className="text-end">
                                                        <h6>
                                                            {usdCurrencyFormat(
                                                                calculatedTotalAmount["totalCredit"].toFixed(2)
                                                            )}
                                                        </h6>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </>
                                    ) : (
                                        <tbody className="pdf-table-row">
                                            <tr>
                                                <td colSpan={9} className="text-center">
                                                    {t("table.summary.no.data")}
                                                </td>
                                            </tr>
                                        </tbody>
                                    )
                                }
                                {/* </tbody> */}
                            </table>

                        </div>
                    </div>
                </div>
            </div>
            {
                showCreateAdjustmentModal ?
                    <CreateTransactionAdjustmentModal
                        show={showCreateAdjustmentModal}
                        glAccounts={glAllAccount}
                        onHide={() => setShowCreateAdjustmentModal(false)}
                        onSave={submitAdjustment}
                        filterAllAccountList={filterAllAccountListExceptBankSales}
                        selectedCalendar={selectedCalendar}
                    /> : <></>
            }

        </div>

    )
}

export default ViewRegister;